import React from "react";
import '../assets/styles/Project.scss';

function Patent() {
    return (
        <div className="projects-container" id="patents">
            <h1>Patents</h1>
            <div className="patents-grid">
                <div className="patent-card">
                    <div className="patent-status-badge">US Patent &bull; Published &bull; US-20260148835-A1</div>
                    <h2 className="patent-title">
                        AI-Powered Personalized Mobile System for Scientific Spiritualism, Cognitive Evolution and Holistic Consciousness Enhancement
                    </h2>
                    <p className="patent-description">
                        A United States patent application published by the United States Patent and Trademark
                        Office (USPTO) — representing original, protected AI technology developed and filed under
                        my name. This patent demonstrates the ability to not only apply AI knowledge but to
                        actively create it: novel, non-obvious, and legally defensible technology recognised by
                        one of the most rigorous intellectual property systems in the world.
                    </p>
                    <div className="patent-meta">
                        <span>Patent No. US-20260148835-A1</span>
                        <span>Published: 28 May 2026</span>
                        <span>Jurisdiction: United States</span>
                        <span>Publisher: USPTO</span>
                    </div>
                    <a
                        className="patent-link"
                        href="https://ppubs.uspto.gov/pubwebapp/external.html?q=(20260148835).pn."
                        target="_blank"
                        rel="noreferrer"
                    >
                        View Patent on USPTO &rarr;
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Patent;
